import {orderConfirmationBillingInformationStyles} from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationBillingInformation"
import { css } from "styled-components"

orderConfirmationBillingInformationStyles.billingInformationTitleGridItem = {
    width: 12,
    css: css`background: #f8f8f8`
}